import { types, async } from '~/utils/typeCreator'

export default types(
  [
    ...async('LOAD_VIEW_NOTICE_EVALUATION_FORM'),
    ...async('LOAD_VIEW_NOTICE_EVALUATION_ANSWERS'),
    'CLEAR_STATE',
  ],
  'VIEW_NOTICE_EVALUATION'
)
